import each from 'lodash/each'

type ApiAction = import('types/api').ApiPayloadAction
type ApiRequestConfig = import('types/api').ApiRequestConfig


export const create = (action: ApiAction): ApiRequestConfig => {
  return {
    url: '/graph/kinds',
    method: 'POST',
    data: {
      id: action.payload.id,
      label: action.payload.label,
      styles: action.payload.styles
    }
  }
}

export const edit = (action: ApiAction): ApiRequestConfig => {
  const req: ApiRequestConfig & { data: Record<string, unknown> } = {
    url: `/graph/kinds/${action.payload.id}`,
    method: 'PUT',
    data: {}
  }
  each(['label', 'styles'], (k: string) => {
    if (action.payload[k] != null) {
      req.data[k] = action.payload[k]
    }
  })
  return req
}

const deleteKind = (action: ApiAction): ApiRequestConfig => {
  return {
    url: `/graph/kinds/${action.payload.id}`,
    method: 'DELETE'
  }
}

export { deleteKind as delete }
